import { IConfig } from '@cian/config/shared';

export const isBuilderWithEscrow = (builderId: number, config: IConfig) => {
  const escrowBuilders = config.get<number[]>('Countryside.EscrowBuilders');

  return !!escrowBuilders?.includes(builderId);
};
